var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12,
    stroke: "#003B6F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_31_7549)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4485 18.3334C14.6305 18.306 14.0137 18.1005 13.415 17.8174C12.4463 17.3608 11.5873 16.7307 10.7876 16.0275C9.70007 15.0686 8.73591 14.0047 7.92711 12.7992C7.46103 12.1005 7.05891 11.37 6.8213 10.5617C6.66594 10.0275 6.60197 9.48411 6.75276 8.93159C6.83958 8.61196 7.00865 8.34255 7.24169 8.10968C7.71235 7.64392 8.17843 7.1736 8.64452 6.70328C8.69935 6.64849 8.7222 6.65762 8.77247 6.70785C9.73662 7.67589 10.7054 8.63936 11.6741 9.60283C11.7335 9.66219 11.7243 9.68959 11.6695 9.73981C11.144 10.2649 10.6185 10.79 10.093 11.3106C10.0428 11.3608 10.0291 11.3928 10.0793 11.4567C11.0709 12.7672 12.1813 13.9636 13.5521 14.8905C13.6207 14.9362 13.6527 14.9362 13.7121 14.8768C14.2238 14.3563 14.7448 13.8403 15.2565 13.3197C15.3205 13.2558 15.3525 13.2558 15.4119 13.3197C16.3669 14.2786 17.3265 15.2375 18.2861 16.1919C18.3455 16.2512 18.3546 16.2832 18.2907 16.3471C17.8429 16.7855 17.3951 17.2284 16.9564 17.6805C16.4949 18.1553 15.9374 18.3426 15.4485 18.3334Z",
    fill: "#003B6F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31_7549"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.6659,
    height: 11.6667,
    fill: "white",
    transform: "translate(6.66602 6.66699)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneV2);
export default __webpack_public_path__ + "static/media/phoneV2.58ba7f11cb4348a707c8de4068f93f47.svg";
export { ForwardRef as ReactComponent };